import { render, staticRenderFns } from "./StressTestFeatureComponent.vue?vue&type=template&id=4077a907&scoped=true&"
import script from "./StressTestFeatureComponent.vue?vue&type=script&lang=js&"
export * from "./StressTestFeatureComponent.vue?vue&type=script&lang=js&"
import style0 from "./StressTestFeatureComponent.vue?vue&type=style&index=0&id=4077a907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077a907",
  null
  
)

export default component.exports